import { useContext } from 'react';
import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import { ThemeMachine } from '../../theme';
import type { DefaultSettableTheme, DefaultThemeDefinition } from '../../theme';
import { windowIsAvailable } from '../../utils';

import { ConfigurationContext } from './Configuration';

export interface ThemeOverrideProps {
  /** Content that will inherit theming overrides. */
  children: ReactNode;
  /** Theme object used to override theme properties. */
  theme: DefaultSettableTheme;
}

const ThemeOverride = ({ children, theme }: ThemeOverrideProps) => {
  const context = windowIsAvailable
    ? window.cosmos.configurationContext ?? ConfigurationContext
    : ConfigurationContext;

  const ctx = useContext(context);

  const themeMachine = new ThemeMachine<DefaultThemeDefinition>({
    theme,
    parent: ctx.themeMachine
  });

  return (
    <context.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{ ...ctx, themeMachine }}
    >
      <ThemeProvider theme={themeMachine.theme}>{children}</ThemeProvider>
    </context.Provider>
  );
};

export default ThemeOverride;
